import React from 'react';
import { ArrowRight } from 'lucide-react';
import { company, media, serviceAreas } from '../data/site';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const stats = [{
  value: '500+',
  label: 'Projects Completed'
}, {
  value: '15+',
  label: 'Years of Trade Experience'
}, {
  value: '100%',
  label: 'Licensed & Insured'
}];
export function About() {
  return <section id="about" className="w-full bg-white py-24 lg:py-32" data-id="element-17" data-mp="33rrm9xsebbt5">
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20" data-id="element-18" data-mp="33pf69q677biq">
        <Reveal className="relative" data-id="element-19" data-mp="3dhb89cbenls8">
          <div className="relative aspect-[4/5] w-full overflow-hidden bg-mist-100 sm:aspect-[4/3] lg:aspect-[4/5]" data-id="element-20" data-mp="3dick3j08wcb0">
            <img src={media.crew} alt="Pure Build Construction foreman reviewing plans on a residential job site" className="h-full w-full object-cover" data-id="element-21" data-mp="3hhv50es2gndu" />
          </div>
          <div className="absolute -bottom-8 left-0 hidden w-56 bg-navy px-7 py-7 text-white sm:block lg:-right-10 lg:left-auto" data-id="element-22" data-mp="3rehniwwx72cp">
            <p className="font-heading text-5xl font-extrabold leading-none" data-id="element-23" data-mp="2grmhlqje5nnl">15+</p>
            <p className="mt-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-white/50" data-id="element-24" data-mp="2cq9a7c0nhcek">
              Years building in Middle Tennessee
            </p>
          </div>
        </Reveal>

        <div data-id="element-25" data-mp="34hgto5vvz86s">
          <Reveal data-id="element-26" data-mp="34i8d6ic7lfgp">
            <SectionHeading label="About Pure Build" title={<>
                  Built with
                  <br data-id="element-28" data-mp="30ihfrvs6g137" />
                  <span className="text-brand-500" data-id="element-29" data-mp="2vp56csw2k0v1">purpose.</span>
                </>} description="Pure Build Construction is a locally owned firm committed to excellence on every project we take on — from a single poured slab to a full custom build." data-id="element-27" data-mp="34gnjeuxpy0jw" />
          </Reveal>

          <Reveal delay={0.1} data-id="element-30" data-mp="3jefw7fbvsaue">
            <p className="mt-6 max-w-xl text-base leading-relaxed text-mist-600" data-id="element-31" data-mp="3je7m1v757jmw">
              Our journey started with a passion for building and a simple standard: do the work the way it should be
              done, communicate clearly, and stand behind it. That standard shows up in the materials we specify, the
              crews we send, and the way a site looks at the end of the day.
            </p>
          </Reveal>

          <Reveal delay={0.15} data-id="element-32" data-mp="1cr3m82j72zq">
            <dl className="mt-12 grid grid-cols-3 gap-6 border-t border-mist-200 pt-8" data-id="element-33" data-mp="3jk72r4bj5ftk">
              {stats.map(s => <div key={s.label} data-id="element-34" data-mp="3okmfpurwglb0">
                  <dt className="font-heading text-3xl font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-35" data-mp="3ohqkie7fsaq9">
                    {s.value}
                  </dt>
                  <dd className="mt-2 text-[11px] font-semibold uppercase leading-snug tracking-[0.14em] text-mist-600" data-id="element-36" data-mp="3emf1hjozwhcp">
                    {s.label}
                  </dd>
                </div>)}
            </dl>
          </Reveal>

          <Reveal delay={0.2} data-id="element-37" data-mp="1crxv450y5rto">
            <p className="mt-10 text-[11px] font-semibold uppercase tracking-[0.18em] text-mist-400" data-id="element-38" data-mp="2xbjke43d11pn">
              Serving {serviceAreas.join(' · ')}
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-6" data-id="element-39" data-mp="2t8wq7wj7v4pa">
              <a href="#why" className="group inline-flex items-center gap-3 border-b-2 border-navy pb-2 font-heading text-[13px] font-bold uppercase tracking-[0.16em] text-navy transition hover:border-brand-500 hover:text-brand-600" data-id="element-40" data-mp="373fivg9cytue">
                Learn more about us
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden="true" data-id="element-41" data-mp="3c3k1bbtttyn9" />
              </a>
              <a href={company.phoneHref} className="text-sm font-bold text-mist-600 transition hover:text-brand-600" data-id="element-42" data-mp="3l1njpz9imfau">
                or call {company.phone}
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}